import { BOOK } from "../content";
import { useCart } from "../context/CartContext";

const StickyBuyBar = () => {
  const { addToCart } = useCart();
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 sm:hidden border-t border-[#D4AF37]/20 bg-[#052730]/90 backdrop-blur-xl px-4 py-3 flex items-center justify-between gap-4" data-testid="sticky-buy-bar">
      <div>
        <div className="flex items-baseline gap-2">
          <span className="font-display text-xl font-bold text-[#F59E0B]">${BOOK.price.toFixed(2)}</span>
          <span className="text-xs text-[#94A3B8] line-through">${BOOK.originalPrice.toFixed(2)}</span>
        </div>
        <p className="text-[10px] text-[#94A3B8]">Instant PDF + email link</p>
      </div>
      <button
        data-testid="sticky-add-to-cart-button"
        onClick={addToCart}
        className="rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-semibold text-[#052730] active:scale-[0.97] transition-transform"
      >
        Add to Cart
      </button>
    </div>
  );
};

export default StickyBuyBar;
